module.exports = __webpack_public_path__ + "img/out-of-budget-name-icon.4d287b3b.svg";